
class Currency
{
    static format( price )
    {
        const string = price + '';
        const pence = ( '00' + string.substr( -2 ) ).slice( -2 );
        const pounds = string.substr(0,string.length-2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        return `£${ pounds || 0 }.${ pence }`;
    }
}

export default Currency.format;
